import { KineticText, SectionLabel } from "@/components/site/primitives";

// Shared page hero for interior pages
export const PageHero = ({ label, titleLines, intro, testId }) => (
  <section data-testid={testId} className="pt-[120px] md:pt-[150px] pb-16 md:pb-20 px-5 md:px-10 border-b border-raritan-border">
    <div className="max-w-[1400px] mx-auto">
      <SectionLabel className="mb-8">{label}</SectionLabel>
      <h1 className="font-heading font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl lg:text-8xl text-raritan-ink">
        <KineticText lines={titleLines} />
      </h1>
      {intro && (
        <p className="mt-8 max-w-2xl font-body text-lg md:text-xl text-raritan-muted leading-relaxed">{intro}</p>
      )}
    </div>
  </section>
);

export default PageHero;
